import {useEffect} from 'react'
import {useCustomerType} from '@salesforce/commerce-sdk-react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {
    buildOptimizelyAttributes,
    normalizeCustomerGroups,
    normalizeLoyaltyTier
} from '../utils/optimizely-attributes'
import {getVisitorId} from '../utils/optimizely-visitor-id'
import {setFxTrackingContext} from '../utils/optimizely-fx-events'
import {useOptimizelyFxConfig} from './use-optimizely-fx-config'

/*
 * Keeps the FX tracking context (enabled, sdkKey, visitor id, session
 * attributes) in sync with the session. Visitor-level attributes (device,
 * referrer, geo…) are merged at send time by optimizely-fx-events. Values are
 * consumed only inside effects, so SSR/hydration output is untouched.
 */
export function useOptimizelyFxTracking() {
    const {enabled, sdkKey, brandSlug, localeId} = useOptimizelyFxConfig()
    const {isRegistered} = useCustomerType()
    const {data: customer} = useCurrentCustomer()
    const customerGroupsCsv = normalizeCustomerGroups(customer?.c_customerGroups).join(',')
    const loyaltyTier = isRegistered ? normalizeLoyaltyTier(customer?.c_loyaltyMostRecentTier) : ''

    useEffect(() => {
        setFxTrackingContext({
            enabled,
            sdkKey,
            userId: getVisitorId() || 'anonymous',
            attributes: buildOptimizelyAttributes({
                brandSlug,
                localeId,
                isLoggedIn: !!isRegistered,
                customerGroups: customerGroupsCsv ? customerGroupsCsv.split(',') : [],
                loyaltyTier
            })
        })
    }, [enabled, sdkKey, brandSlug, localeId, isRegistered, customerGroupsCsv, loyaltyTier])
}
